import favicon from '@images/favicon.ico';
import ogImage from '@images/ogImage.png';
import clsx from 'clsx';
import {motion} from 'motion/react';
import {ReactNode, useEffect} from 'react';
import {APP_ANIMATIONS, APP_TITLE} from '@/const';
import styles from './styles.module.scss';

interface IScreenProps {
    children?: ReactNode;
    screenTitle?: string;
    screenDescription?: string;
    screenStyles?: string[];
}

const Screen = ({children, screenTitle, screenDescription, screenStyles = []}: IScreenProps) => {
    const prefix = APP_TITLE;
    const baseUrl = window.location.origin;
    const title = screenTitle ? `${prefix} | ${screenTitle}` : prefix;
    const description = screenDescription ? screenDescription : title;

    useEffect(() => {
        const titles = document.querySelectorAll('head title');
        titles?.length && titles?.forEach((title, i) => i > 0 && title?.remove());
    }, []);

    return (
        <motion.div
            {...APP_ANIMATIONS.fadeInOut}
            transition={{duration: 0.2}}
            className={clsx(styles.screen, ...screenStyles)}
        >
            <title>{title}</title>
            <meta name={'title'} content={title} />
            <meta name={'description'} content={description} />

            <meta name={'og:type'} property={'og:type'} content={'website'} />
            <meta name={'og:url'} property={'og:url'} content={baseUrl} />
            <meta name={'og:image'} property={'og:image'} content={ogImage} />
            <meta name={'og:title'} property={'og:title'} content={title} />
            <meta name={'og:description'} property={'og:description'} content={description} />

            <meta name={'twitter:card'} property={'twitter:card'} content={'summary_large_image'} />
            <meta name={'twitter:url'} property={'twitter:url'} content={baseUrl} />
            <meta name={'twitter:image'} property={'twitter:image'} content={ogImage} />
            <meta name={'twitter:title'} property={'twitter:title'} content={title} />
            <meta name={'twitter:description'} property={'twitter:description'} content={description} />

            <link rel={'shortcut icon'} href={favicon} type={'image/x-icon'} />
            <link rel={'icon'} href={favicon} type={'image/x-icon'} />

            {children}
        </motion.div>
    );
};

export default Screen;
